export const sendNotificationUrl = "/notification";